import React, { useRef, useState } from 'react';
import './style.scss';
import CarouselSlider from '../../../Shared/components/Carousel/shared/slider/index.js';
import { SwiperSlide } from 'swiper/react/swiper-react.js';
import { CardsListGridCard } from '../gridView/card/index.js';
import clsx from 'clsx';
import CardsListCardRewardsContent from '../cardParts/rewards/content/index.js';
import { v1 as uuid } from 'uuid';
const CardsListCarouselView = ({
  sizeX,
  cards,
  selectCard,
  cardsSelected,
  selectable,
  rewardsOpenedFor,
  openRewards,
  darkMode,
  dontShowCompare,
  setRewardsOpenedFor,
  t,
}) => {
  const [offset, setOffset] = useState(0);

  const defaultCardsState = {
    shouldRenderRewards: null,
    slideSectionLabel1: null,
    slideSectionLabel2: null,
    slideSectionIcons: null,
    slideSectionDescription: null,
    card: null,
  };
  const [cardInfo, sertCardInfo] = useState(defaultCardsState);

  const showHideAndSetRespectiveData = (
    shouldRenderRewards,
    slideSectionLabel1,
    slideSectionLabel2,
    slideSectionIcons,
    slideSectionDescription,
    card
  ) => {
    sertCardInfo({
      shouldRenderRewards,
      slideSectionLabel1,
      slideSectionLabel2,
      slideSectionIcons,
      slideSectionDescription,
      card,
    });
  };

  const contentItemRef = useRef();

  return (
    <div className="content grid-view">
      <CarouselSlider
        className={clsx('swiper-with-bottom-padding-animation', sizeX < 768 ? 'mobile-css' : '')}
        slidesPerView="auto"
        lang="en"
        style={
          sizeX < 768 && rewardsOpenedFor
            ? { paddingBottom: contentItemRef?.current?.clientHeight + 50, marginBottom: 50 }
            : { paddingBottom: 50 }
        }
        onSlideSwap={() => {
          sertCardInfo(defaultCardsState);
          setRewardsOpenedFor(null);
        }}
        hidePaginationOnMobiles="true"
        bulletClassName={clsx('carousel-bullet', !darkMode && 'carousel-bullet-light')}
        breakpoints={{
          400: {
            spaceBetween: 8,
          },
          500: {
            spaceBetween: 16,
          },
          768: {
            spaceBetween: 32,
          },
        }}
      >
        {cards.map((card) => {
          const {
            slideSectionLabel1,
            slideSectionLabel2,
            slideSectionIcons,
            slideSectionDescription,
          } = card.fields;

          const shouldRenderRewards =
            !!slideSectionLabel1?.value ||
            !!slideSectionLabel2?.value ||
            !!slideSectionDescription?.value ||
            !!slideSectionIcons?.length > 0;

          return (
            <SwiperSlide
              key={uuid()}
              className="clcv-carousel-slide"
              onClick={() =>
                showHideAndSetRespectiveData(
                  shouldRenderRewards,
                  slideSectionLabel1,
                  slideSectionLabel2,
                  slideSectionIcons,
                  slideSectionDescription,
                  card
                )
              }
            >
              <CardsListGridCard
                sizeX={sizeX}
                data={card}
                onSelect={() => selectCard(card)}
                isSelected={cardsSelected.includes(card.id)}
                selectable={selectable}
                rewardsOpened={rewardsOpenedFor === card.id}
                openRewards={() => openRewards(card.id)}
                dontShowCompare={dontShowCompare}
                t={t}
              >
                {sizeX < 768 && shouldRenderRewards && (
                  <CardsListCardRewardsContent
                    topHeading={slideSectionLabel1}
                    bottomHeading={slideSectionLabel2}
                    description={slideSectionDescription}
                    iconsList={slideSectionIcons}
                    opened={rewardsOpenedFor === card.id}
                    oneCard
                    contentItemRef={contentItemRef}
                    onHeightChange={(height) => setOffset(height)}
                  />
                )}
              </CardsListGridCard>
            </SwiperSlide>
          );
        })}
        {sizeX >= 768 && (
          <div className="wrap-CardsListCardRewardsContent">
            {cardInfo?.shouldRenderRewards && (
              <CardsListCardRewardsContent
                topHeading={cardInfo?.slideSectionLabel1}
                bottomHeading={cardInfo?.slideSectionLabel2}
                description={cardInfo?.slideSectionDescription}
                iconsList={cardInfo?.slideSectionIcons}
                opened={rewardsOpenedFor === cardInfo?.card?.id}
                oneCard
                onHeightChange={(height) => setOffset(height)}
              />
            )}
          </div>
        )}
      </CarouselSlider>
    </div>
  );
};

export default CardsListCarouselView;
